import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

import "./assets/css/bootstrap.css";
import "./assets/css/global.css";

import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

import AppAlert from "./components/UI/AppAlert/AppAlert";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <>
          <AppAlert />
          <App />
        </>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
